export enum MessageType {
  PING = 'PING',
  PONG = 'PONG',
  OFFER = 'OFFER',
  CHANGE_VIEW = 'CHANGE_VIEW',
  AUTHENTICATE = 'AUTHENTICATE',
  WS_READY = 'WS_READY',
  WAITING_FOR_NEW_AMOUNT_ACCEPT = 'WAITING_FOR_NEW_AMOUNT_ACCEPT',
  AUTHORIZATION_ADDRESS_DATA = 'AUTHORIZATION_ADDRESS_DATA',
}

export enum BusinessParamName {
  SESSION_ID = 'Session-Id',
  SESSION_SIMPLE_ID = 'Session-Simple-Id',
  SESSION_STAGE = 'Session-Stage',
  SESSION_RECREATE_ID = 'Session-Recreate-Id',
  CALCULATION_ID = 'Calculation-Id',
  STORAGE_CALCULATION_DATA_IN_PORTAL = 'Storage-Calculation-Data-In-Portal',
  OFFER_ID = 'Offer-Id',
  CONFIGURATION_CODE = 'Configuration-Code',
  SALES_CHANNEL = 'Sales-Channel',
  CACHE_OFFER = 'Cache-Offer',
  MAIL_NOTIFICATION = 'Mail-Notification',
  RECALCULATION_OFFER = 'Recalculation-Offer',
  ORDER_ID = 'Order-Id',
  INSURANCE_COMPANY_CODE = 'Insurance-Company-Code',
  CALCULATION_SIMPLE_ID = 'Calculation-Simple-Id',
  REFERENCE_OFFER_ID = 'Reference-Offer-Id',
  PARTNER_SHORT_NAME = 'Partner-Short-Name',
  CALCULATION_SOURCE = 'Calculation-Source',
  CLIENT_SOURCE = 'Client-Source',
  APPLICATION_ID = 'Application-Id',
  CHANGED_OFFER = 'Changed-Offer',
  SELECTED_USER_FILTERS = 'Selected-User-Filters',
  PARTNER_CALCULATION_ID = 'Partner-Calculation-Id',
  LOGGED_USER_ID = 'Logged-User-Id',
  LAST_2_YEARS_OC_DAMAGES = 'Last-2-years-oc-damages',
  LAST_5_YEARS_OC_DAMAGES = 'Last-5-years-oc-damages',
  ORIGIN = 'Origin',
  PARTNER_EXTERNAL_ID = 'Partner-External-Id',
  QUOTATION_ID = 'Quotation-Id',
  CONTEXT = 'Context',
  ANALYTICS_USER_ID = 'Analytics-User-Id',
  ANALYTICS_CLIENT_ID = 'Analytics-Client-Id',
  ANALYTICS_SESSION_ID = 'Analytics-Session-Id',
  OFFER_PACKAGE_NAME = 'Offer-Package-Name',
  APPLICATION_CONTEXT = 'Application-Context',
  PORTAL_PARTNER_ID = 'Portal-Partner-Id',
  PORTAL_USER_ID = 'Portal-User-Id',
  DEVICE_SERIAL_NUMBER = 'Device-Serial-Number',
  OFFER_PRIMARY_COVERAGES = 'Offer-Primary-Coverages',
  INVALID_PARTNER_NAME = 'Invalid-Partner-Name',
}

export enum BusinessParamValue {
  WWW = 'WWW',
  REMOTE = 'REMOTE'
}

export enum TechnicalParamName {
  OPERATION_NAME = 'Operation-Name',
  CALLBACK_NOTIFICATION = 'Callback-Notification',
  DESTINATION = 'Destination',
  TASK_CONTEXT_DATA = 'Task-Context-Data',
  READ_ONLY = 'Read-Only',
}

export enum TechnicalParamValue {
  CALCULATION = 'CALCULATION',
  WEB_SOCKET = 'CALCULATION_WEB_SOCKET',
  SUBMIT_ORDER_POLICY = 'SUBMIT_ORDER_POLICY',
  BPS = 'BPS',
  PREPARE_REGISTRATION = 'PREPARE_REGISTRATION',
  MODIFY_OFFER_UNIQA = 'MODIFY_OFFER_UNIQA',
  MODIFY_OFFER_AXA_DIRECT = 'MODIFY_OFFER_AXA_DIRECT',
}
